module.exports = "<span class=\"js-anchor form-label__error-button-anchor\"></span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/fields/templates/errorButton.hbs
// module id = 697
// module chunks = 0